export default __webpack_public_path__ + "static/media/designing-actionable-metrics.5129d997.pdf";